import { i18n } from '@/i18n';
import { onboardingPhoneRegExp } from '@/rules/regexp/Phone';
import { FormKitRule } from '@/types/interfaces/ValidationRule.interface';

/** @deprecated Should export just FormKitPattern. Rule part should be removed, use 'matches' with imported regex instead. */
export function PhoneFormKitRule(minlength = 6, maxlength = 15, required = false): FormKitRule {
  const validation = [['length', minlength, maxlength]];

  if (required) {
    validation.unshift(['required']);
  }

  return {
    name: 'phone',
    rule: (node) => typeof node.value === 'string' && !onboardingPhoneRegExp.expression.test(node.value),
    message: ({ name }) => i18n.global.t('validation.invalid_field', [name]),
    validation,
    pattern: {
      expression: onboardingPhoneRegExp.expression,
      maxlength,
    },
  };
}
